import { useQuery } from '@tanstack/react-query';
import { useSharingStatus } from './useSharingStatus';
import { useCustomerService } from '../../customer/services/customerService';
import type { Customer } from '../../../types/backend';

interface UseCustomerDeploymentsOptions {
  customerId: string | undefined;
  isOpen: boolean;
}

export const customerDetailKeys = {
  detail: (customerId: string | undefined) => ['service-administration', 'customer-detail', customerId] as const,
};

export function useCustomerDeployments({ customerId, isOpen }: UseCustomerDeploymentsOptions) {
  const customerService = useCustomerService();
  const { shares, loading, error } = useSharingStatus(customerId || '');

  const customerQuery = useQuery({
    queryKey: customerDetailKeys.detail(customerId),
    queryFn: () => customerService.getCustomerById(customerId as string),
    enabled: isOpen && !!customerId,
  });

  return {
    customer: (isOpen ? customerQuery.data ?? null : null) as Customer | null,
    shares,
    loading,
    error,
  };
}
